import { TableRowData } from "../../data";

export const REPLACE_TABLE_DISPLAY_DATA : string = 'tabledisplaydata:replace-table-display-data';

export interface TableDisplayDataAction {
  type: typeof REPLACE_TABLE_DISPLAY_DATA;
  payload: TableRowData[];
}